/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/**
 * BROWSER POLYFILLS
 */
import '@angular/localize/init';
import 'url-polyfill';
import 'zone.js';

import { addNonAngularErrorHandlers } from '@libs/src/logger/error-logger.helper';

// TODO: Remove after angular fixes zone.js https://github.com/angular/angular/issues/45020
document.addEventListener('mousemove', () => {}, {
  capture: true,
  passive: false,
});

addNonAngularErrorHandlers();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window;

// Browsers that support it will give deeper stacktraces
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/stackTraceLimit
(Error as { stackTraceLimit?: number }).stackTraceLimit = 60;
